<template>
	<div class="ui modal" ref="modal">
		<div class="content">
			Izbrana gradiva so dodana v vašo iZbirko. 
		</div>
		<div class="actions">
			<div class="ui yellow button approve" v-on:click="close">V iZbirko</div>
		</div>
	</div>
</template>

<script>
	import popup from './Popup.vue'

    export default {
    	mixins: [popup],
    	props: ['data'],
    	methods: {
    		close() {
        		window.location.href = this.route('izbirka');
        	}
    	}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/modals/FreeSuccess.vue